import { FC } from "react";

interface Props {
  label: string;
  active: boolean;
  onClick: () => void;
  noarrow?: boolean;
}

const baseStyle = "flex py-12 px-0 text-xs font-bold border-t justify-center";
const defaultStyle = "bg-white border-b border-gray-200";
const activeStyle = "bg-white border-b-0 border-black";

const SearchDropdownButton: FC<Props> = ({
  label,
  active,
  onClick,
  noarrow = false,
}): JSX.Element => {
  return (
    <button
      className={[baseStyle, active ? activeStyle : defaultStyle].join(" ")}
      onClick={onClick}
    >
      <span className={`flex-1 truncate ${noarrow ? "" : "pl-8"}`}>
        {label}
      </span>
      {!noarrow && (
        <i
          className={`${active ? "icon-Arrow-up" : "icon-Arrow-down"} text-xl`}
        />
      )}
    </button>
  );
};
export default SearchDropdownButton;
